import React from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { PayPalButtons } from '@paypal/react-paypal-js';

const PaymentPage = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handleStripeSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    const card = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card,
    });

    if (error) {
      console.error(error);
    } else {
      console.log('Stripe PaymentMethod:', paymentMethod);
      // Handle payment confirmation and backend integration here
    }
  };

  const handlePayPalApprove = (data, actions) => {
    return actions.order.capture().then((details) => {
      console.log('PayPal Payment Approved:', details);
      // Handle PayPal payment confirmation here
    });
  };

  return (
    <div className="payment-page">
      <h2>Choose Your Payment Option</h2>

      <div className="stripe-payment">
        <h3>Pay with Credit/Debit Card</h3>
        <form onSubmit={handleStripeSubmit}>
          <CardElement />
          <button type="submit" disabled={!stripe}>
            Pay with Card
          </button>
        </form>
      </div>

      <div className="paypal-payment">
        <h3>Pay with PayPal</h3>
        <PayPalButtons
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: '3.00', // Adjust the amount dynamically based on user selection
                  },
                },
              ],
            });
          }}
          onApprove={handlePayPalApprove}
        />
      </div>

      <div className="pricing-options">
        <h3>Pricing</h3>
        <ul>
          <li>$3 - Basic Result</li>
          <li>$5 - Full Report</li>
          <li>$19.99/month (billed yearly) - Unlimited Scans</li>
          <li>$29.99/month - Unlimited Scans</li>
        </ul>
      </div>
    </div>
  );
};

export default PaymentPage;